<template>
  <div class="view-monolith">
    <h2 class="product-desc__title--fixed">Возможности персонализации</h2>
    <Monolith/>
  </div>
</template>

<script>
import Monolith from '@/components/Catalog/Monolith'

export default {
  name: 'ViewMonolith',
  components: {
    Monolith
  }
}
</script>

<style lang="scss">
.view-monolith {
  @at-root .fp-enabled & {
    height: calc(100vh - #{$header-height});
  }
}

@import '@/styles/fixed-title.scss';
</style>
